import { useMemo } from 'react';

import { AnimatePresence } from 'framer-motion';

import useProductPanel from '../../../../../hooks/productpanel/useProductPanel';

import UniversalTablePagination from '../../../../Tables/universalRecord/UniversalTablePagination';

import QuotationPriceCheckItem from './QuotationPriceCheckItem';
import QuotationPriceCheckPlaceholder from './QuotationPriceCheckPlaceholder';

const QuotationPriceCheckCardView = () => {
  const {
    filteredProducts,

    paginator,

    pageSize,

    currentFilter,

    fetchFilteredProducts,

    updateCurrentPage,

    updatePageSize,
  } = useProductPanel();

  const products = useMemo(() => {
    return filteredProducts.filter(
      (p, index, self) =>
        index === self.findIndex((q) => q.id === p.id && q.name === p.name)
    );
  }, [filteredProducts]);

  const handlePageChange = (page: number) => {
    updateCurrentPage(page);

    fetchFilteredProducts(currentFilter || {}, page, pageSize);
  };

  const handlePageSizeChange = (size: number) => {
    updatePageSize(size);

    updateCurrentPage(0);

    fetchFilteredProducts(currentFilter || {}, 0, size);
  };

  if (products.length === 0) {
    return <QuotationPriceCheckPlaceholder mode="card" />;
  }

  return (
    <div className="space-y-4">
      <div
        className="
          grid
          grid-cols-2
          gap-3

          md:grid-cols-3

          xl:grid-cols-4

          2xl:grid-cols-5
        "
      >
        <AnimatePresence>
          {products.map((product) => (
            <QuotationPriceCheckItem
              key={product.id}
              product={product}
              mode="card"
            />
          ))}
        </AnimatePresence>
      </div>

      <UniversalTablePagination
        paginator={paginator}
        data={products}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      />
    </div>
  );
};

export default QuotationPriceCheckCardView;
